<template>
  <div class="login-left">
    <a href="/" class="logo-wrapper">
      <img class="logo" :src="logo" :alt="logoTitle" />
    </a>

    <slot></slot>
  </div>
</template>

<script>
import { trans } from '@/munio/i18n'

export default {
  data() {
    return {
      code: null,
      codeError: null,
    }
  },

  computed: {
    logo() {
      return this.$store.state.company.logoUrl || Munio.config.account.logo.header
    },

    logoTitle() {
      return this.$store.state.company.name || Munio.config.account.name
    },
  },

  methods: {
    trans,

    async applyInviteCode() {
      if (!this.code) return

      this.$store.commit('loading', true)

      try {
        let { data } = await Munio.api.auth.checkInvite(this.code)
        this.$store.commit('updateUsernameResult', {
          type: 'invite',
          result: data,
        })
      } catch (error) {
        this.codeError = trans('The invitation code ":code" could not be found.', {
          code: this.code,
        })
      }

      this.$store.commit('loading', false)
    },
  },
}
</script>
